import { combineReducers } from 'redux';
import placemarks from './placemarks';

export default combineReducers({
  placemarks,
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js